const panels = {
  deleteDialogTitle: 'Delete Model',
  deleteDialogBody: 'Delete this CAD model and all related files?',
  modelList: {
      emptyTitle: 'No models',
      emptyDescription: 'Upload a CAD file',
      setComparisonTarget: 'Set as comparison target',
      delete: 'Delete',
      editClassification: 'Edit organization details',
      searchLabel: 'Search CAD models',
      searchPlaceholder: 'Search filename, model, number, or tag',
      folderFilter: 'Filter by folder',
      allFolders: 'All folders',
      unclassified: 'Unclassified',
      noResults: 'No CAD models match these filters.',
    },
  classification: {
      optionalTitle: 'Organization details (optional)',
      folder: 'Folder',
      folderPlaceholder: 'Example: Products/Model A',
      machineModel: 'Machine model',
      machineModelPlaceholder: 'Example: Model A',
      managementNumber: 'Number',
      managementNumberPlaceholder: 'Example: W136',
      tags: 'Tags',
      tagsPlaceholder: 'Example: DR, production, review (comma separated)',
      help: 'Use “/” for nested folders. Up to 20 comma-separated tags are supported.',
      editTitle: 'Edit CAD organization details',
      editDescription: 'Updates only the folder, tags, machine model, and number; analysis results are unchanged.',
      batchEditTitle: 'Edit batch organization details',
      batchEditDescription: 'Updates only the folder, tags, machine model, and number used in the list; analysis results are unchanged.',
      editAction: 'Organize',
      updateFailed: 'Could not save the organization details. Reload the latest state and retry after processing finishes.',
      saving: 'Saving…',
    },
  modelSelect: {
      label: 'CAD Model',
      none: 'Do not select a CAD model',
      empty: 'No analyzed CAD models are available',
      loadFailed: 'Failed to load CAD models',
    },
  upload: {
      dropLabel: 'Drag and drop a CAD file',
      processing: 'Processing... {{progress}}%',
      unsupportedFormat: 'Unsupported file format: {{extension}}\nSupported formats: {{formats}}',
      noExtension: 'The file name has no extension: {{name}}\nSupported formats: {{formats}}',
      rejectedFiles: '{{count}} file(s) were not added:\n{{reasons}}',
      moreReasons: 'and {{count}} more reason(s)',
      batchLimited: 'Only {{max}} files can be analyzed at once; the first {{max}} were added.',
      fileTooLarge: 'File size exceeds {{size}} MB',
      failed: 'Upload failed',
    },
  viewer: {
      selectModel: 'Select a model.',
      loadFailed: 'Failed to load the 3D model',
      retry: 'Retry',
      loading: 'Loading...',
      hideGrid: 'Hide grid',
      showGrid: 'Show grid',
      showSolid: 'Show solid',
      showWireframe: 'Show wireframe',
      fit: 'Fit',
      reset: 'Reset',
      selectPartPoint: 'Click the location to register as a part',
    },
  chat: {
      selectModel: 'Select a model to start chatting',
      guidance: 'Ask about the CAD model',
      sampleSize: 'What is the rough size of this part?',
      sampleManufacturing: 'Suggest a manufacturing method',
      sampleQuality: 'What quality checkpoints matter?',
      placeholder: 'Enter a question...',
      error: 'An error occurred. Please try again.',
      threadCompareTitle: '[3DCAD] Compare: {{modelA}} vs {{modelB}}',
      threadTitle: '[3DCAD] {{model}}',
    },
  ai: {
      selectModel: 'Select a model.',
      title: 'AI Analysis',
      analyzing: 'Analyzing...',
      reanalyze: 'Reanalyze',
      reanalyzeConfirm: {
        title: 'Re-run AI analysis',
        description:
          'The existing AI analysis will be overwritten and the previous result cannot be restored. Are you sure you want to re-run it?',
        confirm: 'Re-analyze',
      },
      start: 'Start Analysis',
      description: 'Run GPT-4 analysis from design and manufacturing viewpoints.',
      failed: 'AI analysis failed',
    },
  marker: {
      source: {
        pre_label: 'Predefined label',
        hotspot: 'Analysis hotspot',
        llm_inferred: 'LLM inferred',
      },
    },
  markerDetail: {
      title: 'Failure Mode Details',
      noData: 'No DRBFM data is linked to this position.',
      groupedCount: '{{count}} failure modes are linked to the same location.',
      confidence: 'Confidence {{value}}%',
      cause: 'Cause',
      effect: 'Effect',
      part: 'Part',
      locationEvidence: 'Location Link Reason',
      relatedDocuments: 'Related Technical Documents',
    },
  metadata: {
      empty: 'No metadata',
      title: 'Metadata',
      dimensions: 'Dimensions',
      boundingBox: 'Bounding Box',
      volume: 'Volume',
      surfaceArea: 'Surface Area',
      geometry: 'Geometry',
      triangleCount: 'Triangle Count',
      vertexCount: 'Vertex Count',
      edgeCount: 'Edge Count',
      faceCount: 'Face Count',
      file: 'File',
      originalFormat: 'Original Format',
      originalFileSize: 'Original File Size',
      glbSize: 'GLB Size',
      nonWatertightMesh: 'Non-watertight mesh',
      wallThickness: 'Wall Thickness',
      confidence: {
        high: 'High confidence',
        medium: 'Approximate',
        low: 'Low confidence',
      },
      min: 'Min',
      median: 'Median',
      mean: 'Mean',
      max: 'Max',
      thinAreas: 'Thin Areas',
      detectedCount: '{{count}} detected',
      meshQuality: 'Mesh Quality',
      watertight: 'Watertight',
      yes: 'Yes',
      no: 'No',
      bodyCount: 'Body Count',
      degenerateFaces: 'Degenerate Faces',
      draftRisk: 'Draft Risk',
      undercutFraction: 'Undercut Fraction',
      riskRegionCount: 'Risk Region Count',
      count: '{{count}} items',
      pullDirection: 'Pull Direction',
      analysisScope: 'Analysis Scope',
      target: 'Target',
    },
};

export default panels;
